import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Layout } from "components";
import { useLanguage } from "hooks";

export default function InfoTypes() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";

  return (
    <Layout>
      <div id="info_type_page" className="page_container pt-5">
        <section className="mb-3">
          <Container>
            <Row className="mb-4 mb-md-5">
              <Col xs={12}>
                <h2 className="fw-bold text-primary">{language.InfoTypes}</h2>
              </Col>
            </Row>
            <Row className="justify-content-around">
              <Col sm={4} xs={8} className="p-0">
                {/* information type (book) card start */}
                <div className="mx-1 mb-2 about_us_card bg-white border border-light3 border-2 rounded-3 py-4 h-100`">
                  <Row className="justify-content-center">
                    <Col xs={4}>
                      <img src="/images/ebook.png" className="w-100" alt="" />
                    </Col>
                    <Col xs={12}>
                      <Link to="/books">
                        <h2 className="fw-bold text-light3 text-center w-100">
                          {language.books}
                        </h2>
                      </Link>
                    </Col>
                  </Row>
                </div>
                {/* information type (book) card end */}
              </Col>
              <Col sm={4} xs={8} className="p-0">
                {/* information type (magazines) card start */}
                <div className=" mx-1 mb-2 about_us_card bg-white border border-light3 border-2 rounded-3 py-4 h-100`">
                  <Row className="justify-content-center">
                    <Col xs={4}>
                      <img
                        src="/images/magazine.png"
                        className="w-100"
                        alt=""
                      />
                    </Col>
                    <Col xs={12}>
                      <Link to="/magazines">
                        <h2 className="fw-bold text-light3 text-center w-100">
                          {language.magazines}
                        </h2>
                      </Link>
                    </Col>
                  </Row>
                </div>
                {/* information type (magazines) card end */}
              </Col>
              <Col sm={4} xs={8} className="p-0">
                {/* information type (multimedia) card start */}
                <div className=" mx-1 mb-2 about_us_card bg-white border border-light3 border-2 rounded-3 py-4 h-100`">
                  <Row className="justify-content-center">
                    <Col xs={4}>
                      <img src="/images/e-book.png" className="w-100" alt="" />
                    </Col>
                    <Col xs={12}>
                      <Link to="/multimedia">
                        <h2 className="fw-bold text-light3 text-center w-100">
                          {language.multimedia}
                        </h2>
                      </Link>
                    </Col>
                  </Row>
                </div>
                {/* information type (multimedia) card end */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
}
